// extracted by mini-css-extract-plugin
export default {"title":"NotesCard_title__z7Dgu","wrapper":"NotesCard_wrapper__RKV6z","open":"NotesCard_open__iaVrC","value":"NotesCard_value__EKmUk"};